import { Component, OnInit } from '@angular/core';
import { Meta } from '@angular/platform-browser';
import { GlobalComponent } from 'src/app/global/global.component';
import { SeoService } from 'src/app/service/seo.service';

@Component({
  selector: 'login-cofounder',
  templateUrl: './cofounder.component.html',
  styleUrls: ['./cofounder.component.scss']
})
export class CofounderComponent implements OnInit {

  hostName = GlobalComponent.hostName;

  constructor(private SEOService:SeoService) { }

  ngOnInit(){

  this.SEOService.updateCanonicalUrl(this.hostName + '/blog/First-Year-as-a-founder');
  window.scrollTo(0, 0);

  }

}
